import React from 'react'
import identity from 'lodash/identity'
import { QueryParamsObserver } from 'src/observers'
import useHandler from './useHandler'

/**
 * Return value and setter of a url query param by its name
 */
export default function useQueryParam(name, { parse = identity, stringify = identity } = {}) {
  const [value, onChange] = QueryParamsObserver.useState(name)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const parsedValue = React.useMemo(() => parse(value), [value])

  // create setter
  const setValue = useHandler(value => onChange(stringify(value)))

  // return parsed value and setter with the same API than React.useState
  return [parsedValue, setValue]
}

export const DateQueryOptions = {
  parse: str => str && new Date(str),
  stringify: date => date && new Date(date).toISOString(),
}

export const ArrayQueryOptions = {
  parse: (value = []) => [value].flat(),
}
